import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from "react";

const StepOne = forwardRef(({ formData, setFormData }, ref) => {
  const [errors, setErrors] = useState({});

  useImperativeHandle(ref, () => ({
    validate: () => {
      const newErrors = {};

      if (!formData.courseTitle?.trim()) {
        newErrors.courseTitle = "Course Title is required";
      }
      if (!formData.coursesubTitle?.trim()) {
        newErrors.coursesubTitle = "Course Subtitle is required";
      }

      if (!formData.courseDes?.trim()) {
        newErrors.courseDes = "Course Description is required";
      }

      setErrors(newErrors);

      // Return true if there are no errors
      return Object.keys(newErrors).length === 0;
    },
  }));

  useEffect(() => {
    if (formData.courseTitle && errors.courseTitle) {
      setErrors((prev) => ({ ...prev, courseTitle: null }));
    }
    if (formData.coursesubTitle && errors.coursesubTitle) {
      setErrors((prev) => ({ ...prev, coursesubTitle: null }));
    }
    if (formData.courseDes && errors.courseDes) {
      setErrors((prev) => ({ ...prev, courseDes: null }));
    }
  }, [formData, errors.courseTitle, errors.courseDes]);

  return (
    <div className="card-default-style step-form-holder">
      <div className="step-form-holder-inner mx-auto my-10 my-lg-17">
        <h2 className="ah-heading-04 fw-bold text-center mb-10 mb-sm-20 mb-md-32">
          Course Information
        </h2>

        <div className="form-group mb-16 mb-md-24">
          <label htmlFor="courseTitle" className="form-label fw-semibold mb-8 mb-lg-12">
            Course Title
          </label>
          <input
            type="text"
            className="form-control" // Removed conditional class
            placeholder="Enter Course Title"
            id="courseTitle"
            value={formData.courseTitle || ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                courseTitle: e.target.value,
              }))
            }
          />
          {errors.courseTitle && (
            <div className="invalid-feedback d-block">{errors.courseTitle}</div>
          )}
        </div>
        <div className="form-group mb-16 mb-md-24">
          <label htmlFor="courseTitle" className="form-label fw-semibold mb-8 mb-lg-12">
            Course subtitle
          </label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Course Subtitle"
            id="coursesubTitle"
            value={formData.coursesubTitle || ""}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                coursesubTitle: e.target.value,
              }))
            }
          />
          {errors.coursesubTitle && (
            <div className="invalid-feedback d-block">{errors.coursesubTitle}</div>
          )}
        </div>
        <div className="form-group mb-16 mb-md-24">
          <label htmlFor="courseDes" className="form-label fw-semibold mb-8 mb-lg-12">
            Course Description
          </label>
          <textarea
            className="form-control h-auto"
            id="courseDes"
            rows="8"
            value={
              formData.courseDes ||
              ""
            }
            placeholder="Enter Course Description"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                courseDes: e.target.value,
              }))
            }
          />
          {errors.courseDes && (
            <div className="invalid-feedback d-block">{errors.courseDes}</div>
          )}
        </div>
      </div>
    </div>
  );
});

export default StepOne;
